import { isoDate } from "../constants"

export class Rechnungsdaten {
    // BT-10
    leitwegId = ""
    // BT-14
    auftragsnummer = ""
    // BT-13
    bestellnummer = ""
    // BT-1
    rechnungsnummer = ""
    // BT-11
    projektreferenz = ""
    // BT-12
    vertragsnummer = ""
    // BT-3
    rechnungsart = "380" //default Handelsrechnung
    // BT-5
    waehrungRechnung = "EUR"

    // BT-6 - Nach Abstimmungen in Rahmen von EPE-1210 entfernt, siehe Kommentar in https://jira.de.nortal.com/browse/EPE-1210

    // BT-17
    vergabenummer = ""
    // BT-18
    objektkennung = ""
    // BT-18-1
    objektkennungMuster = ""
    // BT-19
    kontierungsinformationen = ""
    // BT-15
    refEmpfangsbestaetigung = ""
    // BT-16
    refVersandanzeige = ""
    // BT-23
    businessKontext = "urn:fdc:peppol.eu:2017:poacc:billing:01:1.0"
    // BT-20
    zahlungsbedingungen = ""
    // BT-2
    rechnungsdatum = isoDate
    // BT-9
    faelligkeitsdatum: string | undefined
    // BT-7
    kontierungsinfoUSt: string | undefined
    // BT-8
    kontierungsinfoUStCode = ""
    // BT-73
    abrechnungszeitraumVon: string | undefined
    // BT-74
    abrechnungszeitraumBis: string | undefined

    toJSON() {
        return {
            ...this,
            rechnungsdatum: this.rechnungsdatum ? this.rechnungsdatum.substr(0, 10) : null,
            faelligkeitsdatum: this.faelligkeitsdatum ? this.faelligkeitsdatum.substr(0, 10) : null,
            kontierungsinfoUSt: this.kontierungsinfoUSt ? this.kontierungsinfoUSt.substr(0, 10) : null,
            abrechnungszeitraumVon: this.abrechnungszeitraumVon ? this.abrechnungszeitraumVon.substr(0, 10) : null,
            abrechnungszeitraumBis: this.abrechnungszeitraumBis ? this.abrechnungszeitraumBis.substr(0, 10) : null,
        }
    }
}
